/******************************************
 *  Author : Suraj Sharma
 *  Created On : Tue Dec 22 2020
 *  File : Types.js
 *******************************************/

export const FETCH_TREES = 'FETCH_TREES';
export const UPDATE_TREES_STATUS = 'UPDATE_TREES_STATUS';
export const CHOOSE_TREES = 'CHOOSE_TREES';
export const UN_CHOOSE_TREES = 'UN_CHOOSE_TREES';
export const STORE_MEETING_DATA = 'STORE_MEETING_DATA';
export const UPDATE_PLANTED_TREES_COUNT_STATUS = 'UPDATE_PLANTED_TREES_COUNT_STATUS';
export const UPDATE_ALLOWED_TREES_COUNT_STATUS = 'UPDATE_ALLOWED_TREES_COUNT_STATUS';
export const CLAIM_TREE_REQUEST = 'CLAIM_TREE_REQUEST';
export const RESET_TREE_STATE = 'RESET_TREE_STATE';
export const CLEAR_TREE_TRANSACTION = 'CLEAR_TREE_TRANSACTION';
export const CLEAR_CHOOSEN_TREES = 'CLEAR_CHOOSEN_TREES';
export const UPDATE_COMPANY_TREES_STATUS = 'UPDATE_COMPANY_TREES_STATUS';
export const FETCH_COMPANY_TREES = 'FETCH_COMPANY_TREES';